export default {
  APP_VERSION: '/wapi/v1/user/app/version',
  COUNTRY_LIST: '/wapi/v1/user/country/list2',
  VARIETY_LIST: '/wapi/v1/user/variety/list2',
  
  USER_INFO: '/wapi/v2/user/security/getUser',
  INVITE_BIND: '/wapi/v1/activity/channel/bind',
  LOGIN_CHECK_ACCOUNT: '/wapi/v1/user/security/login/exist',
  LOGIN: '/wapi/v2/user/security/login',
  LOGOUT: '/wapi/v1/user/security/logout',
  LOGIN_REFERRAL: '/wapi/v1/user/security/registerPrevious',
  LOGIN_3RD_AUTH: '/wapi/v1/user/security/auth/login',

  LOGIN_3RD_AUTH_V2: '/wapi/v2/user/security/auth/login',

  SEND_EMAIL_CODE: '/wapi/v2/user/email/resend',
  SEND_MOBILE_CODE: '/wapi/v2/user/mobile/resend',
  SEND_MOBILE_CHANNEL_LIST: '/wapi/v1/user/mobile/sms/channelTypeList',

  AUTH_GET_RULE: '/wapi/v1/auth/getrule',
  AUTH_VERIFY_OPTION: '/wapi/v1/auth/verify',

  GA_BIND: '/wapi/v1/user/security/bindGA',
  GA_UNBIND: '/wapi/v1/user/security/unbindGA',
  GA_KEY: '/wapi/v1/user/security/getGAKey',

  FIND_PW_EXIST: '/wapi/v1/user/security/findPassword/exist',
  FIND_PW_RESET: '/wapi/v1/user/security/findPassword/reset',

  UPDATE_PW: '/wapi/v1/user/security/modifyPassword',

  SET_PIN: '/wapi/v1/user/security/setPinCode',
  UPDATE_PIN: '/wapi/v1/user/security/modifyPinCode',

  BIND_MOBILE_EXIST: '/wapi/v1/user/security/bindMobile/exist',   // 会自动发送短信验证码
  BIND_MOBILE: '/wapi/v1/user/security/bindMobile',

  DELETE_ACCOUNT: '/wapi/v1/user/security/deleteAccount',

  MOBILE_UNBIND: '/wapi/v1/user/security/unbindMobile',
  BIND_EMAIL_EXIST: '/wapi/v1/user/security/bindEmail/exist',
  EMAIL_BIND: '/wapi/v1/user/security/bindEmail',
  EMAIL_UNBIND: '/wapi/v1/user/security/unbindEmail',

  EMAIL_UPDATE_VERIFY: '/wapi/v1/user/security/modifyEmail/verify',
  EMAIL_UPDATE: '/wapi/v1/user/security/modifyEmail',
  MOBILE_UPDATE_VERIFY: '/wapi/v1/user/security/modifyMobile/verify',
  MOBILE_UPDATE: '/wapi/v1/user/security/modifyMobile',

  KYC_PRE_SAVE: '/wapi/v1/user/sumsub/createApplicant', // 前置KYC
  KYC_INFO: '/wapi/v1/user/sumsub/getKyc', // kyc info
  KYC_TOKEN: '/wapi/v1/user/sumsub/getToken', // sumsub kyc token

  KYC_DECLARATION_FORM_GET: '/wapi/v1/user/kyc/declaration/getForm',
  KYC_DECLARATION_FORM_SUBMIT: '/wapi/v1/user/kyc/declaration/submitForm',

  DEPOSIT_PENDING_LIST: '/wapi/v1/user/processing/depositOrders',

  TRANS_EXEMPTION_RULE: '/wapi/v1/user/debt/card/tx/exemption/rule',

  // 欠款还款相关
  DEBT_CREATE_ORDER: '/wapi/v1/user/debt/create/repayment/order',
  DEBT_DETAIL: '/wapi/v1/user/debt/account/home',
  DEBT_UN_PAYMENT_DETAIL: '/wapi/v1/user/debt/deduct/order/detail',
  DEBT_PAYMENT_DETAIL: '/wapi/v1/user/debt/repayment/order/detail',

  /// payment.
  PAYMENT_ORDER: '/wapi/v1/pay/payOrder/getPendingOrder',
  PAYMENT_SUBMIT: '/wapi/v1/pay/payOrder/authPay',

  CARD_TRANS_LIST: '/wapi/v2/user/card/transaction/list', // 卡片流水列表
  CARD_TRANS_DETAIL: '/wapi/v2/user/card/transaction/detail', // 卡片流水详情

  ZENDESK_JWT: '/wapi/v1/zendesk/jwt',  // 获取zendesk jwt
  HELP_CENTER_INFO: '/wapi/v1/help/list', 

  MSG_UNREAD_COUNT: '/wapi/v1/user/message/unReadMessageNum',
  MSG_SET_LAST: '/wapi/v1/user/message/setLast',

  // 删卡付费相关
  /** return
    String? varietyCode;
    String? deletionFee;
   */
  CARD_DELETE_INFO: '/wapi/v1/user/card/deletePreview',
  /** params
   * cardId
   */
  CARD_DELETE_AND_PAY: '/wapi/v1/user/card/payDelete',

  LIVE_DETECT: '/wapi/v1/user/security/userrisk',

  /// todo 以下都不需要0.
  // v2
  EMAIL_LOGIN: '/w3api/v1/user/security/login',
  AUTH_LOGIN: '/w3api/v1/user/security/auth/login',
  LOGIN_GET_CODE: '/w3api/v1/user/security/login/getCode',

  WALLET_BIND: '/w3api/v1/user/security/wallet/bind',
  WALLET_UNBIND: '/w3api/v1/user/security/wallet/unbind',

  BILL_ADDRESS_SAVE: '/wapi/v1/user/card/saveKycAddress',
  BILL_ADDRESS_INFO: '/wapi/v1/user/card/getKycAddress',
  SHIPPING_ADDRESS_INFO: '/wapi/v1/user/card/shippingAddress',
  SHIPPING_ADDRESS_SAVE: '/wapi/v1/user/card/saveShippingAddress',

  APPLY_CARD_ORDER: '/wapi/v1/user/card/apply',
  ASSETS_LOG_LIST: '/wapi/v1/user/asset/log/list2',

  BALANCE_V2: '/w3api/v1/user/asset/balance2',

  // card related.
  CARD_BIN_LIST: '/wapi/v1/user/cardBin/list',
  CARD_AVAILABLE: '/wapi/v1/user/card/totalAvailable', // 卡片可用金额
  CARD_LIST: '/wapi/v1/user/card/list',
  CARD_DETAIL: '/wapi/v1/user/card/detail',
  CARD_BACK_INFO: '/wapi/v1/user/card/backInfo',
  CARD_CHANGE_LABEL: '/wapi/v1/user/card/changeLabel',
  CARD_LIMIT_INFO: '/wapi/v1/user/card/getLimit',
  CARD_LIMIT: '/wapi/v1/user/card/changeLimit',
  CARD_FREEZE: '/wapi/v1/user/card/freeze',
  CARD_UNFREEZE: '/wapi/v1/user/card/unfreeze',

  CARD_APPLY_LIST: '/wapi/v2/user/card/apply/list',
  CARD_APPLY: '/w3api/v1/user/card/apply', // 购卡订单，返回订单id用于调合约首次购卡
  CARD_APPLY_STATUS: '/w3api/v1/user/card/status', // 查询购卡订单状态，首次购卡后轮询订单结果
  CARD_APPLY_ORDER_CANCEL: '/w3api/v1/user/card/cancle', // 取消处理中的购卡订单
  CARD_APPLY_ORDER_TXID: '/w3api/v1/user/card/order/txhash', // 购卡订单关联TXID

  CARD_BIND_WALLET: '/wapi/v1//user/card/bindWallet',

  CARD_CHANGE_PIN: '/wapi/v1/user/card/changePIN',

  CARD_3DS_CHECK: '/wapi/v1/user/card/3ds/getInitiateActionId',
  CARD_3DS_APPROVE: '/wapi/v1/user/card/3ds/approve',

  // v1.
  USER_LOCATION: '/w3api/v1/user/location', // 用户位置信息，用于限制用户使用，默认国家和区号选择等
  // USER_INFO: '/w3api/v1/user/security/getUser',

  APPLY_CARD_COUPON_PREVIEW: '/wapi/v1/user/card/applyPreviewCoupon',  // 购卡优惠券预览，进入购卡页面后首先调用判断用户是否已有默认优惠券资格，输入优惠券调用换去优惠券金额
  APPLY_CARD_PREVIEW: '/wapi/v1/user/card/applyPreview',  // 购卡支付预览
  FIRST_APPLY_CARD: '/w3api/v1/user/card/apply', // 购卡订单，返回订单id用于调合约首次购卡
  FIRST_APPLY_CARD_STATUS: '/w3api/v1/user/card/status', // 查询购卡订单状态，首次购卡后轮询订单结果
  FIRST_APPLY_CARD_ORDER_CANCEL: '/w3api/v1/user/card/cancle', // 取消处理中的购卡订单
  FIRST_APPLY_CARD_ORDER_TXID: '/w3api/v1/user/card/order/txhash', // 购卡订单关联TXID
  
  WALLET_LOGIN: '/w3api/v1/user/security/wallet/login',
  WEB3_LOGOUT: '/w3api/v1/user/security/logout',
  WEB3_LOGIN: '/w3api/v1/user/security/login',
  ROUTINE_LOGIN:'/w3api/v1/user/security/login',

  CURRENCY_LIST: '/wapi/v1/user/currency/list2',
  CURRENCY_LIST_JSON: '/json/currency-flag-list.json',
  CURRENCY_CHANGE: '/wapi/v1/user/app/changeCurrency',
  
  ASSETS_BALANCE: '/w3api/v1/user/asset/balance', // 资产余额
  ASSETS_TRANS_LIST: '/wapi/v1/user/asset/log/list', // 资产流水列表
  ASSETS_TRANS_DETAIL: '/wapi/v1/user/asset/log/detail', // 资产流水详情
  DEPOSIT_ORDER: '/w3api/v1/user/asset/deposit/createOrder', // 充值下单
  DEPOSIT_ORDER_STATUS: '/w3api/v1/user/asset/deposit/status', // 查询充值进度
  DEPOSIT_ORDER_CANCEL: '/w3api/v1/user/asset/deposit/cancle', // 取消处理中的购卡订单
  DEPOSIT_INIT: '/wapi/v1/user/asset/deposit/init', // 充值初始化
  DEPOSIT_ORDER_TXID: '/w3api/v1/user/asset/deposit/txhash', // 同步充币订单txid

  WITHDRAW_INIT: '/wapi/v1/user/asset/withdraw/init', // 提币初始化
  WITHDRAW_APPLY: '/wapi/v1/user/asset/withdraw/apply', // 提币申请
  WITHDRAW_LIST: '/wapi/v1/user/asset/withdraw/list', // 提币列表
  WITHDRAW_CANCEL: '/wapi/v1/user/asset/withdraw/cancel', // 提币取消

  // 以下可能很快就要加
  WITHDRAW_ADDRESS_LIST: '/wapi/v1/user/asset/withdraw/address/list',
  WITHDRAW_ADDRESS_ADD: '/wapi/v1/user/asset/withdraw/address/add',
  WITHDRAW_ADDRESS_DEL: '/wapi/v1/user/asset/withdraw/address/del',

  WITHDRAW_DETAIL: '/wapi/v1/user/asset/withdraw/detail',

  CARD_TRANS_LABEL: '/wapi/v1/user/card/transaction/changeLabel',

  CARD_BILL_LIST: '/wapi/v1/user/card/bill/list',
  CARD_BILL_EXPORT: '/wapi/v1/user/card/bill/export',

  CARD_DELETE_PEVIEW: '/wapi/v1/user/card/deletePreview',
  CARD_DELETE_PAY: '/wapi/v1/user/card/payDelete',
  CARD_DELETE: '/wapi/v1/user/card/delete',
  CARD_ACTIVATE: '/wapi/v1/user/card/activate',

  CARD_TRANSFER: '/w3api/v1/user/card/transfer',

  MESSAGE_LIST: '/wapi/v1/user/message/list',

  REPORT_LOSS: '/wapi/v1/user/card/reportLoss',

  USER_HOME: '/wapi/v1/user/home',

  CARD_APPLY_ORDER_DETAIL: '/wapi/v1/user/card/apply/detail',
  USER_CHANGE_LOCALE: '/wapi/v1/user/app/changeLocale',

  CARD_TX_EXEMPTION_RULE: '/api/v1/user/debt/card/tx/exemption/rule',

  CARD_FIAT_SETTING: '/wapi/v1/pay/getPayAllowCurrencySetting',
  CARD_FIAT_SETTING_STATUS_CHANGE: '/wapi/v1/pay/changePayAllowCurrencyStatus',
  CARD_FIAT_SETTING_CURRENCY_TOGGLE: '/wapi/v1/pay/changePayAllowCurrencySetting',

  CARD_REISSUE_FEE: '/wapi/v1/user/card/reissue/switch',
  CARD_REISSUE_TYPES: '/wapi/v1/user/card/reissue/types',
  CARD_REISSUE_PREVIEW: '/wapi/v1/user/card/reissue/applyPreview',
  CARD_REISSUE_APPLY: '/wapi/v1/user/card/reissue/apply',
  //uv 相关
  CREATE_PV:"/wapi/v1/uv/create_pv",
  BIND_UID:"/wapi/v1/uv/bind_uid",

  GET_ALG_INFO: '/wapi/v1/user/security/getAlgInfo',
  GET_INTERCOM_HMAC: '/wapi/v1/user/security/getHmac',
}
